// src/components/AIMito/intentHelpers.ts
import { store } from 'app/redux/store'; // <<< ADD
import { UpcomingDatesAPI, IUpcomingDate } from 'app/services/upcomingDates';
import { PormoCodesApi, IAnnouncement } from 'app/services/announcements';

// pull both resources in parallel */;
export async function fetchEvents(): Promise<
  [IUpcomingDate[], IAnnouncement[]]
> {
  /* .unwrap() converts the thunk-result into the real payload  */
  const [dates, ann] = await Promise.all([
    store
      .dispatch(
        UpcomingDatesAPI.endpoints.getUpcomingDates.initiate({
          per_page: 100,
          filters: {},
        }),
      )
      .unwrap(), // ➜ IPaginatedResponse<IUpcomingDate>
    store
      .dispatch(
        PormoCodesApi.endpoints.getAnnouncements.initiate({
          per_page: 100,
          filters: {},
        }),
      )
      .unwrap(), // ➜ IPaginatedResponse<IAnnouncement>
  ]);

  /* We only need the .data arrays */
  return [dates.data, ann.data];
}

// single formatter so both intents stay identical */;
// src/components/AIMito/intentHelpers.ts
export function formatEvents(
  [dates, ann]: [IUpcomingDate[], IAnnouncement[]],
  wantCount = false,
) {
  /* ───── helpers ──────────────────────────────────────────────── */
  const fmt = (iso: string) =>
    new Date(iso).toLocaleString(undefined, {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
      timeZoneName: 'short',
    });

  const stripLinks = (txt: string) =>
    txt
      // remove raw URLs
      .replace(/https?:\/\/\S+/gi, '')
      // remove any leftover HTML tags
      .replace(/<[^>]+>/g, '')
      .trim();

  /* ───── count-only branch ────────────────────────────────────── */
  if (wantCount) {
    return `You have ${dates.length} upcoming events and ${ann.length} announcements.`;
  }

  /* ───── Upcoming Events section ──────────────────────────────── */
  const upcomingPart =
    '🔔 Upcoming Events\n' +
    dates.map((d) => `• ${fmt(d.date_title)} – ${d.description}`).join('\n');

  /* ───── Announcements section ─────────────────────────────────‐ */
  const annPart =
    '\n\n📰 Announcements\n' +
    ann
      .map((a) => {
        const start = fmt(a.started_at);
        const end = a.ended_at ? fmt(a.ended_at) : ''; // handle null
        const range = end ? `${start} → ${end}` : start;
        return `• ${a.title} (${range}) – ${stripLinks(a.description)}`;
      })
      .join('\n');

  return upcomingPart + annPart;
}
